"use strict";
export function validateEmailForm(formData) {
  const errors = {};
  if (!formData.selectedTemplate) {
    errors.template = "Please select an email template";
  }
  if (!formData.subject.trim()) {
    errors.subject = "Subject is required";
  }
  if (!formData.body.trim()) {
    errors.body = "Email body is required";
  }
  return errors;
}
export function formatSuccessMessage(candidateCount) {
  return `Successfully sent emails to ${candidateCount} candidate${candidateCount !== 1 ? "s" : ""}`;
}
export function formatErrorMessage(error) {
  if (error instanceof Error) {
    return error.message;
  }
  return "Failed to send emails";
}
